/**
 * Zone Quick Add – AJAX add to cart with cart icon and cart drawer update.
 * Dispatches the theme's cart:update event so cart-icon and cart-items-component update without refresh.
 */
(function () {
  'use strict';

  var CART_UPDATE_EVENT = 'cart:update';
  var CART_ADD_URL = '/cart/add.js';

  /**
   * Get section IDs for cart items (drawer, etc.) so we can request updated HTML in the add response.
   * Always includes 'cart-ajax' so the mini cart drawer can update and show the last added item.
   * @returns {string} Comma-separated section IDs (always includes cart-ajax)
   */
  function getCartSectionIds() {
    var components = document.querySelectorAll('cart-items-component[data-section-id]');
    var ids = [];
    components.forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id) ids.push(id);
    });
    if (ids.indexOf('cart-ajax') === -1) ids.push('cart-ajax');
    return ids.join(',');
  }

  var AJAX_PRODUCT_ADDED_EVENT = 'ajaxProduct:added';

  /**
   * Dispatch the theme's cart update event so cart icon and cart drawer refresh.
   * @param {number} itemCount - Quantity added (for cart icon: added count when source is product-form-component)
   * @param {Object} [sections] - Optional sections HTML from cart/add.js response
   */
  function dispatchCartUpdate(itemCount, sections) {
    var detail = {
      resource: {},
      sourceId: 'zone-quick-add',
      data: {
        source: 'product-form-component',
        itemCount: itemCount,
      },
    };
    if (sections && typeof sections === 'object') {
      detail.data.sections = sections;
    }
    document.dispatchEvent(
      new CustomEvent(CART_UPDATE_EVENT, {
        bubbles: true,
        detail: detail,
      })
    );
  }

  /**
   * Dispatch ajaxProduct:added so the mini cart drawer opens and shows the last added item.
   * @param {Object} addResponse - Full response from cart/add.js (includes key, sections, item_count, etc.)
   * @param {number} [quantity=1] - Quantity added
   */
  function dispatchMiniCartOpen(addResponse, quantity) {
    if (!addResponse) return;
    document.dispatchEvent(
      new CustomEvent(AJAX_PRODUCT_ADDED_EVENT, {
        bubbles: true,
        detail: { product: addResponse, quantity: quantity || 1 },
      })
    );
  }

  /**
   * Add a variant to the cart via AJAX and trigger cart icon + drawer update.
   * @param {string|number} variantId - Variant ID to add
   * @param {number} [quantity=1] - Quantity to add
   * @returns {Promise<{ success: boolean, error?: string }>}
   */
  function addToCart(variantId, quantity) {
    quantity = quantity == null || isNaN(quantity) ? 1 : Math.max(1, parseInt(quantity, 10));
    variantId = String(variantId).trim();
    if (!variantId) {
      return Promise.resolve({ success: false, error: 'Variant ID required' });
    }

    var sectionIds = getCartSectionIds();
    var body = {
      items: [{ id: parseInt(variantId, 10), quantity: quantity }],
    };
    if (sectionIds) {
      body.sections = sectionIds;
    }

    return fetch(CART_ADD_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (_ref) {
        var ok = _ref.ok;
        var data = _ref.data;

        if (ok && !data.status) {
          dispatchCartUpdate(quantity, data.sections || undefined);
          dispatchMiniCartOpen(data, quantity);
          return { success: true };
        }
        var message = (data && (data.description || data.message)) || 'Unable to add to cart';
        return { success: false, error: message };
      })
      .catch(function (err) {
        return { success: false, error: err && err.message ? err.message : 'Network error' };
      });
  }

  /**
   * Handle click on any .zone-quick-add-btn (product card or zone collection).
   */
  function handleQuickAddClick(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    addToCart(variantId, 1)
      .then(function (result) {
        if (result.success) {
          btn.textContent = 'Added';
          setTimeout(function () {
            btn.textContent = label;
            btn.disabled = false;
          }, 1500);
        } else {
          btn.textContent = result.error || 'Error';
          setTimeout(function () {
            btn.textContent = label;
            btn.disabled = false;
          }, 2000);
        }
      })
      .catch(function () {
        btn.textContent = 'Error';
        setTimeout(function () {
          btn.textContent = label;
          btn.disabled = false;
        }, 2000);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest('.zone-quick-add-btn');
    // var overlay = e.target && e.target.closest('.zone-quick-add-overlay');
    // if (overlay && !btn) {
    //   btn = overlay.querySelector('.zone-quick-add-btn');
    // }
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    handleQuickAddClick(btn);
  }, true);

  window.ZoneQuickAdd = {
    addToCart: addToCart,
  };
})();
